import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { CreateWorkOrdersByTemplateListMutation } from '#/graphql/types';
import { createWorkOrdersByTemplateList } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(createWorkOrdersByTemplateList);

const useCreateWorkOrderByTemplateList = () => {
  const [mutation, result] = useMutation<CreateWorkOrdersByTemplateListMutation>(q);
  const createWorkOrdersByTemplateList = useCallback(
    async (assetIdList: string[], templateIdList: string[]) => {
      const response = await mutation({
        variables: {
          assetIdList,
          templateIdList,
        },
      });

      const result = get(response, 'data.createWorkOrdersByTemplateList', undefined);

      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Create failed';
        throw new Error(errorMessage);
      }

      return get(result, 'data', undefined);
    },
    [mutation],
  );

  return { createWorkOrdersByTemplateList, result };
};

export default useCreateWorkOrderByTemplateList;
